import {CSSProperties, FC} from 'react';


export interface IIconSpecVehiclesBmwProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconSpecVehiclesBmw: FC<IIconSpecVehiclesBmwProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <g clipPath="url(#a)"><path d="M20.329 14v-2.83l-2.24-.55-1.567-2.36c-.022-.019-.402-.612-.424-.63-.022-.02.022.018 0 0h-3.692V6.05H3V16.485h1.833a2.013 2.013 0 0 0 1.955 1.465c.937 0 1.712-.631 1.955-1.465H15.401a2.013 2.013 0 0 0 1.955 1.465c.937 0 1.711-.631 1.955-1.465H21V14s-.306.04-.671 0Zm-13.54 2.932a1.02 1.02 0 0 1-1.019-1.018c0-.55.469-1.018 1.018-1.018a1.02 1.02 0 0 1 1.018 1.018 1.02 1.02 0 0 1-1.018 1.018Zm7.011-6.234a.095.095 0 0 1-.096-.096v-1.87c0-.052.04-.096.096-.096h1.616c.033 0 .062.015.077.04l1.258 1.87c.04.064-.004.148-.078.148H13.8v.004Zm3.556 6.234a1.02 1.02 0 0 1-1.018-1.018c0-.55.468-1.018 1.018-1.018a1.02 1.02 0 0 1 1.018 1.018c0 .55-.469 1.018-1.018 1.018Z" /></g>
            <defs><clipPath id="a"><path d="M0 0H18V18H0z" transform="translate(3 3)" /></clipPath></defs>
        </svg>
    );
};
